import Vue from 'vue';

import { E償却項目 } from '@/openapi/enum';

export const enableE償却項目s = [
  E償却項目.資産コード,
  E償却項目.名称,
  E償却項目.償却方法,
  E償却項目.数量,
  E償却項目.事業供用日,
  E償却項目.取得価額,
  E償却項目.耐用年数,
  E償却項目.前期末簿価,
  E償却項目.リース期間月数,
  E償却項目.残価保証額,
] as const;

export default Vue.extend({
  name: 'C固定資産カラムSelect',

  props: {
    value: {
      type: String,
    },
  },

  data(): {
    readonly options: string[];
  } {
    return {
      options: Object.values(enableE償却項目s),
    };
  },

  computed: {
    selected: {
      get(): string | undefined {
        return this.value;
      },
      set(v: string): void {
        this.$emit('update:value', v);
      },
    },
  },
});
